import {useRef } from "react";
import {Link, useLocation, useNavigate} from "react-router-dom";
import {ModelFilterTagInterface} from "../../../interfaces/catalog/ModelFilterTagInterface";

import { Swiper, SwiperSlide } from 'swiper/react';
import { FreeMode } from 'swiper/modules';

export default function ModelFilterTags({tags, resetFilterTag}:{tags: ModelFilterTagInterface[], resetFilterTag: () => void}) {
    const location = useLocation();
    const navigate = useNavigate();
    const swiperRef = useRef(null);

    const getFilterTagName = () => {
        const data = /\/tag\/(.+)\/$/.exec(location.pathname)
        return data?.length ? data[1] : null
    }

    const getBasePath = () => {
        const data = /(.+)\/tag\/.+/.exec(location.pathname)
        return data?.length ? data[1] + '/' : location.pathname
    }



    return (<div className="filters__activities">
        <div className="swiper-wrapper">
            <Swiper
                ref={swiperRef}
                modules={[FreeMode]}
                direction="horizontal"
                slidesPerView="auto"
                freeMode={{
                    enabled: true,
                    sticky: false,
                }}
                simulateTouch={true}
                allowTouchMove={true}
                grabCursor={true}
                spaceBetween={0}
                style={{
                    width: '100%',
                    height: 'auto',
                }}
            >
            {tags.map(tag => <SwiperSlide key={tag.id} className="swiper-slide filters__active"> <Link onClick={(event) => {
                if(getFilterTagName() === tag.slug) {
                    event.preventDefault()
                    resetFilterTag()
                    navigate(getBasePath())
                }
            }} className={getFilterTagName() === tag.slug ? 'active' : ''} to={getBasePath() + 'tag/' + tag.slug + '/'} >{tag.name}</Link></SwiperSlide>)}
            </Swiper>
            </div>
    </div>)
}